import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import RosterApi from "../../../axios/Roster/RosterApi";
import ConfirmActionDialog from "../../../components/ConfirmActionDialog";

const DeleteRosterDialog = (props) => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const { deleteRoster } = RosterApi();

  const handleCloseDialog = () => {
    if (loading) return;
    props.handleClose();
  };

  const handleRemove = async () => {
    // Tour fake roster — không gọi API
    if (props.selectedDeleteRoster?.rosterId === "tour-fake-roster") {
      props.handleClose();
      return;
    }

    setLoading(true);
    try {
      const payload = {
        ...props.selectedDeleteRoster,
        langId: localStorage.getItem("i18nextLngId"),
      };
      await deleteRoster(payload);
      toast.success(t("common.delete-roster-successfully"));
      props.handleClose();
      props.handleRefreshDataAddRoster?.();
    } catch (error) {
      if (error.response) {
        if (error.response.status !== 401) {
          toast.error(t(error?.response.data));
        }
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <ConfirmActionDialog
      open={props.open}
      variant="delete"
      title={t("common.delete-roster-item-confirm", {
        rosterName: props.selectedDeleteRoster?.rosterName || "",
      })}
      subtitle={t("common.delete-roster-item-subtitle")}
      confirmText={t("button.delete")}
      loading={loading}
      onClose={handleCloseDialog}
      onConfirm={handleRemove}
    />
  );
};

export default DeleteRosterDialog;
